import { useEffect, useRef } from 'react';
import { io, Socket } from 'socket.io-client';
import { useAppSelector } from '../reduxToolkit/hooks';

let socket;
const sessionId = crypto.randomUUID();
let socketRole = null;
export const useSocket = (event, handler) => {
  const { role } = useAppSelector((state) => state.auth);
  useEffect(() => {
    if (!socket) {
      socketRole = role;
      socket = io(process.env.REACT_APP_SOCKET_URL, {
        // transports: ['websocket'],
        withCredentials: false,
        path: '/socket.io',
        query: { sessionId, socketRole },
      });
      console.log('Connecting to:', process.env.REACT_APP_SOCKET_URL);

      // 🔴 General error (e.g., CORS, network, etc.)
      socket.on('connect_error', (err) => {
        console.error('❌ Socket connect_error:', err.message, err);
      });

      // 🔴 Connection timeout or issues
      socket.on('connect_timeout', (timeout) => {
        console.error('⏱️ Socket connect_timeout:', timeout);
      });

      // 🔴 Disconnection
      socket.on('disconnect', (reason) => {
        console.warn('⚠️ Socket disconnected:', reason);
      });

      // ✅ Successful connection
      socket.on('connect', () => {
        console.log('✅ Socket connected:', socket.id);
        if (socketRole) {
          socket.emit('register-role', { role: socketRole, sessionId });
        }
      });
      socket.on('bot-state-changed', (data) => {
        // update UI accordingly
      });
    }

    socket.on(event, handler);

    return () => {
      socket.off(event, handler);
    };
  }, [event, handler]);

  useEffect(() => {
    // 3) If role appears/changes later, (re)register it without reconnect
    if (!role) return;

    if (role !== socketRole) {
      socketRole = role;
      if (socket?.connected) {
        socket.emit('register-role', { role, sessionId });
      } else {
        // Will be emitted on the next "connect" via the handler above
      }
    }
  }, [role]);
};
export const getSocketSessionId = () => sessionId;
export const getSocketRole = () => socketRole;
